import React from 'react';
import { connect } from 'react-redux';
import Footer from './footer';
import NavigationBar from './navigation-bar';
import { removeDropdown } from '../../redux/actions/SVOD';
import svodMessages from '../../locales/svod';
import { formatDuration } from '../../functions/time';
import { setSelectedAsset } from '../../redux/actions/SVOD';

class AppleTransactionalPage extends React.Component {
	constructor(props) {
		super(props);

		this.state = {};
		this.onButtonClick = this.onButtonClick.bind(this);
	}

	componentDidMount() {
		this.props.eventHandler({
			data: {
				event_type: 'page_enter',
				page_location: 'transaction',
				asset_name: this.props.video.name,
				asset_id: this.props.video._id,
				time: Date.now(),
			},
		});
	}

	componentWillUnmount() {
		this.props.eventHandler({
			data: {
				event_type: 'page_exit',
				page_location: 'transaction',
				asset_name: this.props.video.name,
				asset_id: this.props.video._id,
				time: Date.now(),
			},
		});
	}

	onButtonClick() {
		const { video } = this.props
		this.props.eventHandler({
			data: {
				event_type: 'transaction',
				page_location: 'transaction',
				asset_name: this.props.video.name,
				asset_id: this.props.video._id,
				time: Date.now(),
			},
		});
		this.props.eventHandler({ 
			data: { 
				event_type: "button_click", 
				type: "watch_on_apple_tv_click", 
				page_location: "transaction",
				asset_id: video._id,
				asset_name: video.name,
				time: Date.now() 
			} 
		});
	}

	render() {
		const { environment, video } = this.props;
		
		return (
			<div className="transaction-page-index index position-relative" id="svod-page">
				<div id="top"></div>
				<NavigationBar {...this.props} backRoute={this.props.backRoute} page="transaction" />

				<div className="title-container">
					<p className="thumbnail-container">
						<img src={video.images.thumbnail} />
					</p>
					<p className="title">{video.content.title}</p>
				</div>
				<div className="video-content-container">
					<div
						className="button-container"
						data-tooltip={`${this.props.intl.formatMessage(svodMessages.not_available)}`}
					>
						<button onClick={this.onButtonClick}>Watch on Apple TV</button>
					</div>
					<div className="video-description-container">
						<p className="description">{video.content.description}</p>
						<span className="metadata">
							{video.content.genres[0]} ⋅ {video.content.year} ⋅ {formatDuration(video.video.duration)}
						</span>
					</div>
				</div>
				<Footer environment={environment} />
			</div>
		);
	}
}

const mapStateToProps = (state) => ({
	video: state.SVOD.selectedAssets.asset,
	videos: state.SVOD.videos,
	appleTVVideos: state.SVOD.appleTVVideos,
	dropdown: state.SVOD.dropdown,
	environment: state.SVOD.environment,
	rowInformation: state.targetProcess.fetchedGroup.svod_env.rows,
	targetAssets: state.targetProcess.fetchedGroup.svod_env.target_assets,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
	removeDropdown: () => dispatch(removeDropdown()),
});

export default connect(mapStateToProps, mapDispatchToProps)(AppleTransactionalPage);



// WEBPACK FOOTER //
// ./src/components/svod/AppleTransactionalPage.js